import { addShadow, checkPosition } from '../shadow';
import { rotateData } from './rotateData';
import { cloneData } from './cloneData';
import { randomItem /*, shuffle*/ } from '../lib/utils';
import { eachFigures } from './eachFigures';
import { USE_ROTATE } from '../app/const/features';
export function hint(slices, data) {
    // let clonedData = cloneData(data)
    // slices = shuffle(slices.slice(0))
    // let iArr: number[] = shuffle(USE_ROTATE ? [0, 1, 2, 3] : [0])
    // let rotation: number = 0
    //
    // for (let i of iArr) {
    //   for (let s = 0; s < slices.length; s++) {
    //     const slice = slices[s]
    //
    //     if (slice.hidden) {
    //       continue
    //     }
    //     const cell = findSpaceRandom(slice, clonedData)
    //
    //     if (cell && Array.isArray(cell)) {
    //       checkPosition(slice, cell, clonedData, true)
    //       // Поворачивание до 360 градусов
    //       while (rotation > 0 && rotation < 4) {
    //         clonedData = rotateData(clonedData, 9)
    //         rotation++
    //       }
    //       return clonedData
    //     }
    //   }
    //   clonedData = rotateData(clonedData, 9)
    //   rotation++
    // }
}
export function usefulHint(slices, data) {
    var iArr = USE_ROTATE ? [0, 1, 2, 3] : [0];
    var rotation = 0;
    var rotatedData = getAllRotations(data);
    var result = [];
    for (var _i = 0, iArr_1 = iArr; _i < iArr_1.length; _i++) {
        var i = iArr_1[_i];
        var _loop_1 = function (s) {
            var slice = slices[s];
            if (slice.hidden) {
                return "continue";
            }
            var bestCell = findSpaces(slice, rotatedData[rotation])
                .map(function (cell) { return ({ cell: cell, q: getQuality(addShadow(slice, cell, rotatedData[rotation])) }); })
                .sort(function (a, b) { return b.q - a.q; })[0];
            if (bestCell) {
                result.push({ slice: slice, bestCell: bestCell.cell, rotation: rotation, q: bestCell.q });
            }
        };
        for (var s = 0; s < slices.length; s++) {
            _loop_1(s);
        }
        rotation++;
    }
    if (result.length) {
        var bestHint = getRandomBestHint(result);
        var hintData = addShadow(bestHint.slice, bestHint.bestCell, rotatedData[bestHint.rotation]);
        if (bestHint.rotation > 0) {
            for (var i = 0; i < 4 - bestHint.rotation; i++) {
                hintData = rotateData(hintData, 9);
            }
        }
        return [hintData, bestHint.slice];
    }
}
function getRandomBestHint(hints) {
    hints.sort(function (a, b) { return b.q - a.q; });
    var bestQuality = hints[0].q;
    hints = hints.filter(function (r) { return r.q === bestQuality; });
    return randomItem(hints);
}
function getAllRotations(data) {
    var rotatedData = [cloneData(data)];
    for (var i = 0; i < 3; i++) {
        rotatedData.push(rotateData(rotatedData[i], 9));
    }
    return rotatedData;
}
function findSpaces(slice, data) {
    var jArr = [-1, 0, 1, 2, 3, 4, 5, 6, 7, 8];
    var iArr = jArr.slice(0);
    var cells = [];
    for (var _i = 0, jArr_1 = jArr; _i < jArr_1.length; _i++) {
        var j = jArr_1[_i];
        for (var _a = 0, iArr_2 = iArr; _a < iArr_2.length; _a++) {
            var i = iArr_2[_a];
            if (checkPosition(slice, [i, j], data)) {
                cells.push([i, j]);
            }
        }
    }
    return cells;
}
function getQuality(data) {
    var quality = 0;
    eachFigures(function (indexes) {
        var count = indexes.map(function (i) { return data[i].value || data[i].shadow; }).filter(function (i) { return Boolean(i); }).length;
        quality += count * 10;
        if (count === 9)
            quality += 50; // Полное заполнение фигуры
        if (count === 8)
            quality += 25;
    });
    // https://docs.google.com/spreadsheets/d/1giKFW1wNlP4Cj0CJZb3DUjrjiqCFNtLpAPlGmbhFMck/edit#gid=319742010
    // // Запертая клетка в углу
    // if (leftTopAngle(data)) quality -= 10
    // if (rightTopAngle(data)) quality -= 10
    // if (leftBottomAngle(data)) quality -= 10
    // if (leftBottomAngle(data)) quality -= 10
    // if (rightBottomAngle(data)) quality -= 10
    //
    // // Запертые клетки в центре поля
    // for (let i of [0, 1, 2, 3, 4, 5, 6]) {
    //   for (let j of [0, 9, 18, 27, 36, 45, 54]) {
    //     // prettier-ignore
    //     let pattern: Pattern = [
    //       [i + j,      true], [1  + i + j,  true], [2  + i + j, true],
    //       [9  + i + j, true], [10 + i + j, false], [11 + i + j, true],
    //       [18 + i + j, true], [19 + i + j,  true], [20 + i + j, true],
    //     ]
    //     if (matchPattern(data, pattern)) {
    //       quality -= 10
    //     }
    //   }
    // }
    return quality;
}
// function leftTopAngle(data: DataItem[]): boolean {
//   // prettier-ignore
//   return matchPattern(data, [[0, false], [1, true], [9, true], [10, true]])
// }
//
// function rightTopAngle(data: DataItem[]): boolean {
//   // prettier-ignore
//   return matchPattern(data, [[8, false], [7, true], [16, true], [17, true]])
// }
//
// function leftBottomAngle(data: DataItem[]): boolean {
//   // prettier-ignore
//   return matchPattern(data, [[72, false], [63, true], [64, true], [73, true]])
// }
//
// function rightBottomAngle(data: DataItem[]): boolean {
//   // prettier-ignore
//   return matchPattern(data, [[80, false], [70, true], [71, true], [79, true]])
// }
//
// type Pattern = [number, boolean][]
//
// function matchPattern(data: DataItem[], pattern: Pattern): boolean {
//   for (let i = 0; i < pattern.length; i++) {
//     const index = pattern[i][0]
//     const value = pattern[i][1]
//
//     if (Boolean(data[index].value || data[index].shadow) !== value) {
//       return false
//     }
//   }
//   return true
// }
